import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBlockSortAscending: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconBlockSortAscending"><Path d="M11 21H3V13H11V21Z" fill="currentColor"/><Path d="M22.707 10.293L21.293 11.707L19 9.41406V18H17V9.41406L14.707 11.707L13.293 10.293L18 5.58594L22.707 10.293Z" fill="currentColor"/><Path d="M11 11H3V3H11V11Z" fill="currentColor"/></CentralIconBase>;
});

export default IconBlockSortAscending;
